/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JustPortfolioViewModel } from './JustPortfolioViewModel';
import {
    JustPortfolioViewModelFromJSON,
    JustPortfolioViewModelFromJSONTyped,
    JustPortfolioViewModelToJSON,
} from './JustPortfolioViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfJustPortfolioViewModel
 */
export interface ResultOfJustPortfolioViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfJustPortfolioViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfJustPortfolioViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfJustPortfolioViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfJustPortfolioViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfJustPortfolioViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfJustPortfolioViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfJustPortfolioViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {JustPortfolioViewModel}
     * @memberof ResultOfJustPortfolioViewModel
     */
    data?: JustPortfolioViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfJustPortfolioViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfJustPortfolioViewModel interface.
 */
export function instanceOfResultOfJustPortfolioViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfJustPortfolioViewModelFromJSON(json: any): ResultOfJustPortfolioViewModel {
    return ResultOfJustPortfolioViewModelFromJSONTyped(json, false);
}

export function ResultOfJustPortfolioViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfJustPortfolioViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : JustPortfolioViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfJustPortfolioViewModelToJSON(value?: ResultOfJustPortfolioViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': JustPortfolioViewModelToJSON(value.data),
        'Count': value.count,
    };
}

